import { Fragment } from "react";
import UIDivider from "../atoms/UIDivider";
import UITitle from "../atoms/UITitle";
import UIHelpCard from "../molecules/UIHelpCard";
import { useLocation } from "react-router-dom";

export default function UIHelp() {
  const location = useLocation();

  return (
    <section className="px-10% pb-[69px] pt-[50px] gap-[30px] flex flex-col relative justify-center items-center">
      {location.pathname !== "/preguntas-frecuentes" && (
        <Fragment>
          <UITitle style={{ color: "#2D2D2D" }} h3 className="text-[32px] font-BNPPSquareBold">
            ¿Necesitas ayuda?
          </UITitle>
          <span className="mb-[40px] text-center px-[10%] font-OpenSans text-[#58595B]">
            Recibe una consultoría completa sobre los beneficios de tu portafolio
            de servicios. Elige alguna de las siguientes opciones:
          </span>
        </Fragment>
      )}

      <div className="flex flex-col bg-white border-b-4 border-secondary-green justify-center overflow-hidden md:justify-between max-w-[80%] w-full md:max-w-[90%] lg:flex-row gap-2 rounded-md py-[35px] px-[24px] md:px-[24px] shadow-[0_1px_12px_rgba(0,0,0,0.1)]">
        {location.pathname !== "/preguntas-frecuentes" && (
          <Fragment>
            <UIHelpCard icon="/assets/icon/icon_help_1.svg" title="Resuelve tus dudas" description="Visita nuestras preguntas frecuentes" link="/preguntas-frecuentes" />
            <UIDivider />
          </Fragment>
        )}
        <UIHelpCard
          icon="/assets/icon/icon_help_2.svg"
          title="Llama a nuestras líneas de atención"
          description="Bogotá:  (601)7423197 /n Nacional: 01 8000 932933"
        />
        <UIDivider />
        <UIHelpCard
          icon="/assets/icon/icon_help_3.svg"
          title="Escríbenos un correo electrónico"
          description="comunicaciones@conectatecontuseguro.com"
          link="mailto:comunicaciones@conectatecontuseguro.com"
        />
      </div>
      <div className="w-full absolute bottom-0 md:h-[50%] bg-[#F8F8F8] z-[-1]"></div>
      <div className="flex bg-[#F8F8F8] z-[-1] top-[590px] md:top-[360px] absolute bottom-0 left-0 right-0 " />
    </section>
  );
}
